import React from 'react';
import { useMilestonesController } from 'controllers/business/Milestones/Milestones.controller';
import Slice from 'components/Slice/Slice';
import { PromotionalCardChromatic } from './components/PromotionalCardChromatic/PromotionalCardChromatic';
import { PromotionalCardsRepeater } from './components/PromotionalCardsRepeater/PromotionalCardsRepeater';

export const usePromotionalCards = () => {
    const { get } = useMilestonesController();

    const hasPerformedChromatic = get('chromaticLoaded');

    const showChromaticPromoCard = !hasPerformedChromatic;

    return { showChromaticPromoCard };
};

export const PromotionalCards = () => {
    const { showChromaticPromoCard } = usePromotionalCards();

    return (
        <Slice>
            {showChromaticPromoCard && <PromotionalCardChromatic />}
            {!showChromaticPromoCard && <PromotionalCardsRepeater />}
        </Slice>
    );
};
